import { isDevelopment } from '../utils/HostingEnv';

export default function DebugInfo({ children, className = '' }) {
  if (!isDevelopment) return null;
  return (
    <div
      className={`${className} py-2 mt-4 text-center noPrint`}
      style={{ backgroundColor: '#ffff99' }}
    >
      {children}
    </div>
  );
}
